import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取job的报关
export function customsList(jobUuid) {
  return request({
    url: URL.seaExport.customsInfo,
    method: 'get',
    params: { jobUuid }
  })
}

// 报关保存
export function customsSave(data) {
  return request({
    url: URL.seaExport.customsInfo,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

// 欧坚报关保存
export function saveOrSend(data) {
  return request({
    url: URL.seaExport.customsInfoSaveOrSend,
    method: 'post',
    data
  })
}

// 删除Job的报关
export function customsDel(uuid) {
  return request({
    url: URL.seaExport.customsInfo + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

// 删除Job的报关 -批量
export function customsInfoDeleteAll(data) {
  return request({
    url: URL.seaExport.customsInfoDeleteAll,
    method: 'delete',
    data
  })
}
// 报关保存
export function ymtCustomsSend(data) {
  return request({
    url: URL.seaExport.ymtCustomsSend,
    method: 'post',
    data
  })
}
// 云贸通报关回执
export function ymtCustomsReceiptInfo(param) {
  return request({
    url: URL.seaExport.ymtCustomsReceiptInfo,
    method: 'get',
    params: { param }
  })
}

// 查询报关单回执日志
export function queryCustomsInfoResLog(params) {
  return request({
    url: URL.seaExport.queryCustomsInfoResLog,
    method: 'get',
    params
  })
}

// 查询报关单回执日志
export function queryFileByOriginFileId(params) {
  return request({
    url: URL.seaExport.queryFileByOriginFileId,
    method: 'get',
    params: params
  })
}

// 报关单高级查询
export function customsInfoAdvancedQuery(data) {
  return request({
    url: URL.seaExport.customsInfoAdvancedQuery,
    method: 'post',
    data
  })
}

// 报关单高级查询
export function customsInfoBatchSave(data, params) {
  return request({
    url: URL.seaExport.customsInfoBatchSave,
    method: 'post',
    data,
    params
  })
}

// 获取报关相关的文件
export function getCustomsFiles(params) {
  return request({
    url: URL.seaExport.getCustomsFiles,
    method: 'get',
    params
  })
}

// 发送报关相关的文件到信号旗
export function xhqSendCustomsFiles(data) {
  return request({
    url: URL.seaExport.xhqSendCustomsFiles,
    method: 'post',
    data
  })
}

export function exportCustomsInfoFunc(data) {
  return request({
    url: URL.seaExport.exportCustomsInfoUrl,
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 查询报关文件发送状态
export function xhqQueryCustomsFilesSendState(params) {
  return request({
    url: URL.seaExport.xhqQueryCustomsFilesSendState,
    method: 'get',
    params
  })
}

// 查询报关文件发送状态
export function xhqRecallCustomsFiles(params) {
  return request({
    url: URL.seaExport.xhqRecallCustomsFiles,
    method: 'get',
    params
  })
}

// 获取信号旗报关信息列表
export function xhqCustomsList(jobUuid) {
  return request({
    url: URL.seaExport.xhqCustomsList,
    method: 'get',
    params: { jobUuid }
  })
}
// 信号旗报关解冻
export function xhqCustomsUnFrozen(data) {
  return request({
    url: URL.seaExport.xhqCustomsUnFrozen,
    method: 'post',
    data
  })
}
// 查询信号旗报关解冻状态
export function xhqGetCustomsUnFrozenState(data) {
  return request({
    url: URL.seaExport.xhqGetCustomsUnFrozenState,
    method: 'post',
    data
  })
}

// 获取信儿跳转链接
export function xhqJumpChatPage(params) {
  return request({
    url: URL.seaExport.xhqJumpChatPage,
    method: 'get',
    params
  })
}

// 获取soNo列表
export function getSoNos(params) {
  return request({
    url: URL.seaExport.getSoNos,
    method: 'get',
    params
  })
}

// 获取报关单日志记录
export function getCustomsInfoLog(params) {
  return request({
    url: URL.seaExport.getCustomsInfoLog,
    method: 'get',
    params
  })
}

// 删除报关文件
export function deleteFileByUuid(params) {
  return request({
    url: URL.seaExport.deleteFileByUuid,
    method: 'get',
    params
  })
}
